<template>
  <div>
    <span>
    Redirecting...
  </span>
    <div ref="loginContainer" style="padding: 0px; border: none; margin: 0px; width: 0px; height: 0px"></div>
  </div>
</template>

<style>
  .callback {
    background: white;
  }
</style>

<script>
/* eslint-disable */
import Vue from "vue";
import userMgr, { refresh_ssrs, refresh_tableau } from "../sso";
import config from "../../config";
import tableau from "tableau-api";
import * as api from "../api";

export default {
  created() {
    let _self = this;
    userMgr.signinRedirectCallback().then(function(user) {
      Vue.http.headers.common["Authorization"] = "Bearer " + user.access_token;
      _self.$store.commit("login", user);

    refresh_ssrs(user.id_token, function() {})

		let path = 'views/dummy/sso';
    api.getViz(path).then(
      resp => {
        let trustedUrl =  config.get("TableauServer") + resp.body.TrustedUrl;
        refresh_tableau(trustedUrl, function(){
          _self.$store.commit("tableau_login")
          _self.$router.push(localStorage.lastPathUrl);
        });
      },
      resp => {
        console.log(resp);
      }
    );
  });
  }
};
</script>


// WEBPACK FOOTER //
// Callback.vue?b041a05a